module.exports = __webpack_public_path__ + "media/4x3/bg-3d762564.svg";